<template>
	<fieldset class="fieldset">
		<div>
			<div class="sr-only">
				<legend><span>Quote type</span></legend>
			</div>
			<div>
				<label><span>Quote type </span>
					<select v-model="form.data.data.conveyancing.quote_type">
						<option value="sale_purchase">Buying & Selling</option>
						<option value="purchase">Buying Only</option>
						<option value="sale">Selling Only</option>
						<option value="remortgage">Remortgaging</option>
					</select>
					<div
						v-if="form.errors.get('data.conveyancing.quote_type')"
						class="error-block">
						<p v-html="form.errors.get('data.conveyancing.quote_type')"></p>
					</div>
				</label>
			</div>
		</div>
	</fieldset>
</template>
<script>
export default {
	props: {
		form: {
			required: true,
			type: Object,
		},
	},
};
</script>
